/**
 * Reject characters outside the Unicode Basic Multilingual Plane (codepoints
 * > U+FFFF). MySQL's default `utf8` charset is actually `utf8mb3` and silently
 * replaces 4-byte chars (most emojis, some CJK extensions) with `?` at write
 * time, corrupting the row permanently. Until the connection is moved to
 * `utf8mb4`, free-text fields that round-trip through the DB must reject
 * those chars at the form layer.
 */
const NON_BMP_REGEX = /[\u{10000}-\u{10FFFF}]/u;

export function nonBmpError(value) {
    if (typeof value !== 'string' || !NON_BMP_REGEX.test(value)) return null;
    return 'Emojis and 4-byte characters are not supported in this field.';
}

/** AntD Form rule shape — drops into a Form.Item `rules` array. */
export const noNonBmpRule = {
    validator: (_, value) => {
        const err = nonBmpError(value);
        return err ? Promise.reject(new Error(err)) : Promise.resolve();
    },
};
